define('common/js/lib/Serum.Time',[
  'jquery',
  'common/js/lib/Serum.Session',
  'common/js/lib/Serum.Pubsub',
  'module'
], function ($, Session, Pubsub, module) {
  'use strict';

  /**
   * fetch server time and publish date object
   * @public
   */
  function now() {
    return adjust(Date.now());
  }

  /**
   * fetch server time and publish date object
   * @public
   */
  function adjust(currentTime){
    var time = Session.get('time') || {diff: 0};
    return new Date(currentTime - time.diff);
  }

  function cacheTime(time) {
    Session.set('time', {
      ts : time,
      diff : Date.now() - time
    });
    Pubsub.publish(Pubsub.topics.TIME_EVENT, now());
  }

  /*function fetchTime() {
    $.ajax({url: module.config().TIME_API})
      .done(function(response) {
        cacheTime(response.time);
      })
      .fail(function() {
        if(window.console) {
          console.log('Failed to fetch server time'); // eslint-disable-line no-console
        }

        cacheTime(new Date().getTime());
      });
  }*/

  function initialize() {
    var ajax = new window.XMLHttpRequest(),
      parsedResponse;

    ajax.onreadystatechange = function(){
      if(ajax.readyState === 4){
        try {
          parsedResponse = JSON.parse(ajax.responseText);
          if (parsedResponse && parsedResponse.time) {
            cacheTime(parsedResponse.time);
          } else {
            cacheTime(Date.now());
          }
        } catch (e) {
          cacheTime(Date.now());
        }
      }
    };
    ajax.open('GET', module.config().TIME_API, true);
    ajax.send();

    /*if (Session.get('time')) {
      Pubsub.publish(Pubsub.topics.TIME_EVENT, now());
    } else {
      fetchTime();
    }*/
  }

  function destroy() {
    Session.remove('time');
  }

  initialize();

  // @interface
  return {
    now : now,
    adjust: adjust,
    initialize: initialize,
    destroy: destroy
  };

});

